// extracted by mini-css-extract-plugin
export default {"carouselItem":"CarouselItem_carouselItem__M9y10"};